import { useMemo } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const REVEAL_VIEWPORT = { once: true, margin: "-70px" };
const REVEAL_VISIBLE = { opacity: 1, y: 0 };
const OVERLINE_VIEWPORT = { once: true };
const OVERLINE_HIDDEN = { scaleX: 0 };
const OVERLINE_VISIBLE = { scaleX: 1 };
const OVERLINE_TRANSITION = { duration: 1, delay: 0.3, ease: EASE };

export const Reveal = ({ children, delay = 0, y = 36, className }) => {
  const hidden = useMemo(() => ({ opacity: 0, y }), [y]);
  // eslint-disable-next-line react-hooks/exhaustive-deps -- EASE is a module-level constant
  const transition = useMemo(() => ({ duration: 0.9, delay, ease: EASE }), [delay]);

  return (
    <motion.div
      initial={hidden}
      whileInView={REVEAL_VISIBLE}
      viewport={REVEAL_VIEWPORT}
      transition={transition}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeader = ({ overline, title, light = false, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-baseline gap-4 mb-6">
      <motion.span
        initial={OVERLINE_HIDDEN}
        whileInView={OVERLINE_VISIBLE}
        viewport={OVERLINE_VIEWPORT}
        transition={OVERLINE_TRANSITION}
        className={`h-px w-12 self-center origin-left ${light ? "bg-ivory/30" : "bg-navy/20"}`}
      />
      <span className={`text-xs uppercase tracking-[0.25em] font-semibold ${light ? "text-ivory/70" : "text-navy/60"}`}>
        {overline}
      </span>
    </div>
    <h2 className={`font-display text-4xl sm:text-5xl leading-[1.08] tracking-tight max-w-2xl ${light ? "text-ivory" : "text-navy"}`}>
      {title}
    </h2>
  </Reveal>
);

export { EASE };
